import axios from "axios";

const PATH = "/accounting";

export default {
    findAvailableOrders(date: string) {
        return axios
          .get(`${PATH}/worklog/availableOrders`, {
              params: {
                  date: date
              }
          });
    }
};
